import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images


import banner1 from './images/pcamkurz.mp4';

import { Grid, Row, Col, Breadcrumb, Button} from 'react-bootstrap';

class PCAM extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/Automatisierung">Automatisierung</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>PCAM</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <div className="videoContainer">
            <video id="background-video" loop autoPlay playsinline="true">
              <source src={banner1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
        <div className="supMainTextLS">
        <h1>PCAM</h1>
          <Grid className="supMainInfo">
            <Row>
              <Col md={12}>
                <h4>CAD / CAM / Automatisierungssysteme stellen heutzutage einen der wichtigsten Bestandteile der industriellen Fertigung dar. Diese Tools entwickelt das Schweizer Unternehmen PCAM um dem Kunden eine effiziente 24/7 Produktion zu ermöglichen. Durch die flexible und kundenorientierte Entwicklung können spezifische Lösungen erarbeitet werden, egal welche Maschine sie einsetzen wollen.
Wir sind davon überzeugt, dass "Menschen den Unterschied machen, denn Grenzen existieren nur in unserer Vorstellung !"</h4>
              </Col>
              <Col xs={12} md={{ span: 7, offset: 2 }}>
                <Button className="supMainButtonWebPage" variant="light" href="https://www.pcam.com/" target="_blank">Hersteller Homepage</Button>
              </Col>
            </Row>
          </Grid>
        </div>
        <br/>
        <section>
        <div className="supMainKeyWords ">
          <br/>
          <Grid>
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Kundenorientiert</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Höchste Qualität</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Deutscher Support</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>24/7 Fertigung</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Absicherung nach nationalen und internationalen Normen</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Eigene Entwicklung</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Kundenorientiert</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Deutscher Support</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; 24/7 Fertigung</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Eigene Entwicklung</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        &nbsp;
        </div>
    );
  }
}

export default PCAM;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/pcam/mainPageSup.js